import { render, staticRenderFns } from "./PsEventFaq.vue?vue&type=template&id=17682601&scoped=true&"
import script from "./PsEventFaq.vue?vue&type=script&lang=js&"
export * from "./PsEventFaq.vue?vue&type=script&lang=js&"
import style0 from "./PsEventFaq.vue?vue&type=style&index=0&id=17682601&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17682601",
  null
  
)

export default component.exports